import axios from "axios";

// Set up default axios instance
const api = axios.create({
  baseURL: process.env.BACK_RND_URL+"/",
  headers: {
    "Content-Type": "application/json",
  },
});

// Leer el token dinámicamente en cada request (evita token fijo al cargar el módulo)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("authToken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const getColCitiesData = async () => {
  try {
    const response = await api.get("cities/colombia");
    return response.data;
  } catch (error) {
    console.error("Error fetching example data", error);
    throw error;
  }
};

export const getUsaCitiesData = async (data) => {
  try {
    const response = await api.get("cities/usa", { params: data });
    return response.data;
  } catch (error) {
    console.error("Error fetching example data", error);
    throw error;
  }
};

export const createShipment = async (data) => {
  try {
    const response = await api.post("create/shipment", data);
    return response.data;
  } catch (error) {
    console.error("Error posting example data", error);
    throw error;
  }
};

export const getAddressUsa = async () => {
  try {
    const response = await api.get("addresses/usa");
    return response.data;
  } catch (error) {
    console.error("Error fetching example data", error);
    throw error;
  }
};

export const getAddressCol = async () => {
  try {
    const response = await api.get("addresses/colombia");
    return response.data;
  } catch (error) {
    console.error("Error fetching example data", error);
    throw error;
  }
};

export const createAdresssCol = async (data) => {
  try {
    const response = await api.post("addresses/create/colombia", data);
    return response.data;
  } catch (error) {
    console.error("Error posting example data", error);
    throw error;
  }
};

export const createAdresssUsa = async (data) => {
  try {
    const response = await api.post("addresses/create/usa", data);
    return response.data;
  } catch (error) {
    console.error("Error posting example data", error);
    throw error;
  }
};



export const downloadFile = async (url, filename = 'guide.latam.shipping') => {
  try {
    const response = await axios.get(url, {
      responseType: 'blob', // Important
    });

    // Create a new Blob object using the response data of the file
    const blob = new Blob([response.data], { type: response.data.type });

    // Create a link element
    const link = document.createElement('a');

    // Create a URL for the Blob and set it as the link's href
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;

    // Append the link to the body
    document.body.appendChild(link);

    // Programmatically click the link to trigger the download
    link.click();

    // Clean up and remove the link
    document.body.removeChild(link);
  } catch (error) {
    console.error('Download failed:', error);
  }
};


export const completeShipment = async (data) => {
  try {
    const response = await api.post("complete/shipment", data);
    return response.data;
  } catch (error) {
    console.error("Error posting example data", error);
    throw error;
  }
};